import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const UserSearchParamsSchema = z
  .object({
    q: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type UserSearchParams = z.infer<typeof UserSearchParamsSchema>

export const UserSearchResultModelSchema = z.object({
  id: z.number(),
  username: z.string(),
  name: z.string(),
  department: z.string().nullable(),
})

export type UserSearchResultModel = z.infer<typeof UserSearchResultModelSchema>

export const UserSearchResultSchema = z
  .object({
    data: z.array(UserSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type UserSearchResult = z.infer<typeof UserSearchResultSchema>
